import {
	Box,
	Button,
	Checkbox, Container, Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	InputAdornment, makeStyles,
	SvgIcon, Table,
	TableBody,
	TableCell,
	TableContainer, TableHead,
	TablePagination,
	TableRow, TextField,
	Tooltip, LinearProgress, Typography
} from "@material-ui/core";
import Fuse from 'fuse.js';
import { useSnackbar } from 'notistack';
import React from "react";
import { Search as SearchIcon } from 'react-feather';
import { useActions, useValues } from 'kea';

import alertlogic from "src/store/alert";
import vehiclelogic from "src/store/vehicle";

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		height: '600px'
	},
}));

const columns = [
	{
		field: 'info',
		headerName: 'Vehicle Details',
		align: 'left',
		width: 400,
	},
	{
		field: 'actions',
		// headerName: 'Select',
		align: 'right',
		width: 100,
	}
];

const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const initialAlertAssignment = {
	vehicles: [],
	timeSlots: []
}

const AddVehicleDialog = ({ selectedAlert, alertIndex }) => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const { add_many } = useActions(alertlogic);

	const [open, setOpen] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const { vehicles } = useValues(vehiclelogic);

	const { alerts } = useValues(alertlogic);

	const [AlertAssignment, setAlertAssignment] = React.useState(initialAlertAssignment);


	const [rows, setRows] = React.useState([]);
	React.useEffect(() => {
		const selectedAlertIds = alerts[alertIndex].vehicles.map((iRow) => {
			return iRow.vehicle._id;
		});

		let unfiltered_rows = vehicles.filter((aRow) => {
			return !selectedAlertIds.includes(aRow._id);
		});
		setRows(unfiltered_rows);
	}, [alerts, selectedAlert]) // eslint-disable-line

	if (!rows) {
		return (
			<>
				<LinearProgress />
			</>
		)
	}
	const fuse = new Fuse(rows, {
		keys: ['tags', 'type', 'name', 'registration_number', 'registration_state', 'company', 'model', 'year', 'color']
	});
	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
		handleReset();
	}

	const handleDone = () => {
		if (AlertAssignment.vehicles.length === 0) {
			enqueueSnackbar('Please select vehicles first.', { variant: 'error' });
			return;
		}
		handle_add();
		handleReset();
		setOpen(false);
		return;
	};

	const handleReset = () => {
		setAlertAssignment({
			vehicles: [],
			timeSlots: []
		});
	};

	const handleChangeVehicle = (value) => {
		let updated = { ...AlertAssignment };
		if (updated.vehicles.includes(value)) {
			updated.vehicles.splice(updated.vehicles.indexOf(value), 1);
		} else {
			updated.vehicles.push(value);
		}
		setAlertAssignment(updated);
	}

	const handle_add = () => {
		let updated_alert = selectedAlert;
		AlertAssignment.vehicles.forEach((vehicle) => {
			updated_alert.vehicles.push({
				schedule: AlertAssignment.timeSlots,
				vehicle: vehicles.find((aRow) => {
					return vehicle === aRow._id;
				}),
				enabled: true
			});
		});

		// update(updated_alert);
		add_many(updated_alert._id, AlertAssignment.vehicles)
		// add_many(updated_alert._id,)
	}

	const handle_search = (e) => {
		if (e.target.value) {
			let found = fuse.search(e.target.value);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setRows(found);
		} else {
			const selectedAlertIds = alerts[alertIndex].vehicles.map((iRow) => {
				return iRow.vehicle._id;
			});

			let unfiltered_rows = vehicles.filter((aRow) => {
				return !selectedAlertIds.includes(aRow._id);
			});
			setRows(unfiltered_rows);
		}
	};

	return (
		<div>
			<Tooltip title="Add Vehicles to this alert">
				<Button
					color="default"
					variant="contained"
					aria-label="update"
					size='large'
					onClick={handleClickOpen}
				>
					Add to Alert
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">
					Add Vehicles to the Alert
					{selectedAlert.condition.monitor === 'stolen' && <Typography align="center" color="secondary">Note - Only add vehicles to a stolen alert, if they are already stolen.</Typography>}
					<div style={{ paddingTop: '20px' }} />
					<TextField
						size="small"
						fullWidth
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon
										fontSize="small"
										color="action"
									>
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							)
						}}
						onChange={handle_search}
						placeholder="Search Vehicles"
						variant="outlined"
					/>
				</DialogTitle>
				<DialogContent >
					<div style={{ width: '1228px', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										rows && rows.length > 0 ?
											rows
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row) => {
													if (!row.enabled) return null;
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Checkbox
																					color="primary"
																					inputProps={{ 'aria-label': 'secondary checkbox' }}
																					checked={AlertAssignment.vehicles.includes(row._id)}
																					onChange={() => handleChangeVehicle(row._id)}
																				/>
																			</TableCell>
																		</>
																	)
																}
																if (column.field === 'info') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				{withTooltip(`${row.type} - ${row.name} - ${row.registration_number}`, column.width)}
																			</TableCell>
																		</>
																	);
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
													No Data Added.
												</TableCell>
											</TableRow>
									}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				</DialogContent>
				<DialogActions>
					<Container maxWidth={false}>
						<Box>
							<TablePagination
								rowsPerPageOptions={[rowsPerPage]}
								component="div"
								count={rows ? rows.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<Tooltip title="Cancel">
									<Button
										color="primary"
										aria-label="update"
										size='large'
										onClick={handleClose}
									>
										Cancel
									</Button>
								</Tooltip>
								<Tooltip title={'Finish'}>
									<Button
										color="primary"
										aria-label="update"
										onClick={handleDone}
									>
										Done
									</Button>
								</Tooltip>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</div>
	);
};

export default AddVehicleDialog;
